import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { ToastAlertComponent } from '@freelancer/ui/toast-alert';

@Injectable({ providedIn: 'root' })
export class ToastAlertService {
  private toastAlerts: { [k: string]: ToastAlertComponent } = {};
  private activeToasts: ToastAlertComponent[] = [];
  private renderer: Renderer2;
  private container: HTMLElement;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  add(toastAlertItem: ToastAlertComponent, id: string) {
    this.toastAlerts = { ...this.toastAlerts, ...{ [id]: toastAlertItem } };
  }

  remove(id: string) {
    delete this.toastAlerts[id];
  }

  open(id: string) {
    const toastAlertItem = this.toastAlerts[id];
    this.container = document.getElementById(
      'toast-alert-container',
    ) as HTMLElement;

    if (typeof toastAlertItem === 'undefined') {
      return;
    }

    if (this.activeToasts.includes(toastAlertItem)) {
      toastAlertItem.resetTimer();
    } else {
      this.renderer.addClass(toastAlertItem.element, 'IsActive');
      this.renderer.appendChild(this.container, toastAlertItem.element);
      toastAlertItem.toggleVisibility('visible');
      toastAlertItem.startTimer();
      this.addToActiveToasts(toastAlertItem);
    }
  }

  close(id: string) {
    const toastAlertItem = this.toastAlerts[id];

    if (typeof toastAlertItem === 'undefined') {
      return;
    }
    toastAlertItem.toggleVisibility('hidden');
    this.activeToasts = this.activeToasts.filter(x => x.id !== id);
    this.repositionItems();
  }

  addToActiveToasts(item: ToastAlertComponent) {
    this.activeToasts = [...this.activeToasts, item];
    this.repositionItems();
  }

  removeElement(id: string) {
    const toastAlertItem = this.toastAlerts[id];

    if (toastAlertItem) {
      this.renderer.removeChild(this.container, toastAlertItem.element);
    }
  }

  private repositionItems() {
    const offset = 8;
    let position = offset;

    this.activeToasts.forEach(item => {
      item.move(position);
      position += item.element.offsetHeight + offset;
    });
  }
}
